import { ISectionLogger } from "@multiweb/logging";
import { PromiseUtils } from "Global/Base/Promises/PromiseUtils";
import { UIUtils } from "Global/Dom/UIUtils";
import { BlockingLayerBuilderDecorator } from "../UI/DataBuilders/BlockingLayerBuilderDecorator";
import { IContentBuilder } from "../UI/DataBuilders/IContentBuilder";
import { UpdateProgressContentBuilder } from "../UI/DataBuilders/UpdateProgressContentBuilder";

const MINIMUM_PROGRESS_TIME_MS = 3000;
const MINIMUM_READY_TIME_MS = 3000;

const enum UpdateState {
    notStarted,
    inProgress,
    ready,
    done,
}

export class AppUpdateProgress {
    private static state = UpdateState.notStarted;
    private static inProgressDisplayed: Promise<void> = Promise.resolve();
    private static _blockingLayer: HTMLElement;
    private static _content: UpdateProgressContentBuilder;

    public static async showUpdateInProgress(rootElementSelector: string, logger?: ISectionLogger): Promise<void> {
        if (this.state !== UpdateState.notStarted)
            return;

        logger?.info("Showing update found overlay");

        this.state = UpdateState.inProgress;

        const deffered = PromiseUtils.defer<void>();
        this.inProgressDisplayed = deffered.promise;

        await UIUtils.waitForDOMReady();

        this._content = new UpdateProgressContentBuilder("GUI-712087"); //Aplikace se právě instaluje, počkejte prosím...
        this._showBlockingLayer(rootElementSelector, new BlockingLayerBuilderDecorator(this._content));

        logger?.debug("Showing update found overlay - started waiting");
        await PromiseUtils.delay(MINIMUM_PROGRESS_TIME_MS);

        deffered.resolve();
    }

    public static _showBlockingLayer(rootElementSelector: string, content: IContentBuilder): void {
        if (AppUpdateProgress._blockingLayer == undefined) {
            AppUpdateProgress._blockingLayer = document.querySelector(rootElementSelector);
            if (AppUpdateProgress._blockingLayer)
                AppUpdateProgress._blockingLayer.tabIndex = -1; //potřeba kvůli tomu, aby případný keyup nad overlayem měl v eventě target element, jinak by tam byl document
        }

        if (AppUpdateProgress._blockingLayer == null)
            return;
        AppUpdateProgress._blockingLayer.style.visibility = "visible";

        if (content)
            content.build().then((data) => {
                AppUpdateProgress._blockingLayer.appendChild(data);
            });
    }

    public static async showUpdateReady(rootElementSelector: string, logger?: ISectionLogger): Promise<void> {
        logger?.debug("Showing update finished overlay 1");

        if (this.state === UpdateState.notStarted)
            await this.showUpdateInProgress(rootElementSelector, logger); // pokud se stránka otevřela až když už je update nachystaný, tak se stejně zobrazí i informace, ze se připravuje

        if (this.state !== UpdateState.inProgress)
            return;

        logger?.debug("Showing update finished overlay 2");

        this.state = UpdateState.ready;

        await UIUtils.waitForDOMReady();

        await this.inProgressDisplayed;
        logger?.debug("Showing update finished overlay - finished waiting for previous stage");

        this._content.hideLoader();
        this._content.updateText("GUI-712583"); //Aplikace byla aktualizována

        await PromiseUtils.delay(MINIMUM_READY_TIME_MS);

        logger?.debug("Showing update finished overlay - triggering update");
        // doběhnutí promisu spustí reload stránky a aktivování nového workeru
        this.state = UpdateState.done;
    }
}
